<template>
  <v-container>
    <template>
      <template>
        <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1" hide-default-footer
          hide-default-header>
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th v-for="h in headers" :class="h.class">
                  <span>{{ h.text }}</span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>
              {{
                item.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>

          <template v-slot:top>
            <!-- <v-toolbar flat> -->
            <!-- <v-toolbar-title>Add Miscellaneous Details</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer> -->
            <v-dialog v-model="dialog" max-width="500px">
              <!-- <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Item
                      </v-btn>
                    </template> -->
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- </v-toolbar> -->
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->
            <v-icon :style="{
              backgroundColor: '#E1F5FE',
              color: '#2196F3',
            }" :disabled="datainv_disable" @click="openeditItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="ml-2" :style="{
              backgroundColor: '#FFEBEE',
              color: '#F44336',
            }" :disabled="datainv_disable" @click="deleteItem(item)">
              mdi-delete
            </v-icon>

          </template>
          <!-- <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template> -->
        </v-data-table>
      </template>
      <div class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
        <template>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field
                    v-model="editedItem.code"
                    ref="txtCode"
                    label="Code"
                    dense
                    outlined
                    @keydown.space="changeFocusText(2)"
                    @keydown.enter="changeFocusText(2)"
                  ></v-text-field> -->

              <v-autocomplete :disabled="datainv_disable" v-model="editedItem.miscellaneous_disbursements"
                :items="miscellaneous_disbursementslist" item-text="title" item-value="title" label="Select"
                ref="MiscellaneousDisbursements" outlined dense @change="
                  onSelectmiscellaneous_disbursementsChange(
                    editedItem.miscellaneous_disbursements
                  )
                  " @keydown.enter="changeFocusText(2)"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" sm="7" md="7">
              <v-text-field
                v-model="editedItem.description"
                ref="txtDescription"
                dense
                outlined
                label="Description"
                @keydown.enter="changeFocusText(3)"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="3" md="3">
              <v-text-field :disabled="datainv_disable" v-model="editedItem.amount" ref="txtAmount" label="Amount"
                type="number" dense outlined @keydown.enter="saveMisTab()"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="editedItem.miscellaneous_disbursements == 'Others'">
            <v-col cols="12" sm="6" md="6" class="mt-n10">
              <v-text-field :disabled="datainv_disable" v-model="editedItem.specify_type" label="Please specify type..."
                ref="SpecifyType" dense outlined @keydown.enter="saveMisTab()"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="mt-n5" align="right">
              <h3 class="colorblack">Total</h3>
            </v-col>

            <v-col cols="12" sm="3" md="3" class="mt-n10" align="left">
              <v-text-field reverse v-model="amount_total" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </v-col>

            <div align="center" class="widthsubtotal"></div>
          </v-row>
        </template>
      </div>
    </template>

    <v-dialog v-model="dialogEdit" max-width="800px">
      <v-card class="pa-8">
        <v-card-title class="text-h6">Service No.{{ dataeditItem.no }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea v-model="dataeditItem.miscellaneous_disbursements" multi-line outlined dense
                label="Service Details"></v-textarea>
            </v-row>
            <v-row>
              <v-col cols="12" md="46">
                <v-text-field type="text" label="Amount" v-model="dataeditItem.amount" outlined dense></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="closeeditItem()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialogInvoice_Mis :status="dialogAddMis" :text_color="text_colorMis" :title="titleMis"
      :message="messageMis" />
  </v-container>
</template>

<script>
import SuccessDialogInvoice_Mis from "@/components/cards/SuccessDialogInvoice_Mis";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  props: ["so_id", "datainv_mis", "datainv_disable"],
  async mounted() {
    this.$showLoader();
    // setTimeout(() => {
    //   this.$hideLoader();
    // }, 500);
    this.$store.state.global_dialog_invoice_mis = false;

    await this.loadmis_list();
    // this.loadAdvanceCode();
    this.desserts = this.datainv_mis;

    this.amount_total = 0;
    this.desserts.forEach((item) => {
      if (item.miscellaneous_disbursements == "Others" && item.specify_type) {
        item.miscellaneous_disbursements = item.specify_type;
      }
      item.amount = parseFloat(item.amount);
      item.amount_show = tolocalestringnumber(item.amount);
      this.amount_total += parseFloat(item.amount);
    });
    this.amount_total = tolocalestringnumber(this.amount_total);
    this.$hideLoader();
  },
  components: {
    SuccessDialogInvoice_Mis,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  data() {
    return {
      amount_total: 0.0,
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogAddMis: false,
      dialogSendMail: false,
      text_colorMis: "text-h5 green--text text-center",
      titleMis: "green",
      messageMis: "green",
      link: "",
      isShowPassword: false,
      fullPage: true,
      advance_code_list: [],
      desserts: [],
      headers: [
        {
          text: "Miscellaneous Disbursements",
          value: "miscellaneous_disbursements",
          class: "my-header4-style ",
        },
        // {
        //   text: "Description",
        //   value: "description",
        //   class: "my-header-style",
        // },
        {
          text: "Amount",
          value: "amount_show",
          class: "my-header2-style text-center",
          align: "end",
        },
        {
          text: "Action",
          value: "actions",
          class: "my-header3-style  text-center",
        },
      ],
      editedItem: {
        miscellaneous_disbursements: "",
        specify_type: "",
        // description: "",
        amount: 0,
      },
      miscellaneous_disbursementslist: [
        // "Publication Fees",
        // "Translation Fees",
        // "Legalization Fees",
        // "Courier Services",
        // "Transportation and photocopies",
        // "Government Fee for Work Permit",
        // "Government Fee for Visa",
        // "Certified Fee",
        // "Others",
      ],
      editedIndex: -1,
      dataeditItem: {
        miscellaneous_disbursements: "",
        amount: 0,
      }
    };
  },
  methods: {
    async loadmis_list() {
      const result = await api.billing_expense_getInvMiscellaneousByCom_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      }
      );
      this.miscellaneous_disbursementslist = result.data;
      this.miscellaneous_disbursementslist.push({ title: "Others" })
    },
    // async loadAdvanceCode() {

    //   let company_id = localStorage.getItem(server.COMPANYID);

    //   const result = await api.getAllAdvanceCodeByCompany(company_id);
    //   this.advance_code = result.data;

    //   result.data.forEach((item) => {
    //     this.advance_code_list.push(item.code + " " + item.description);
    //   });
    // },
    onSelectAdvanceCodeChange(acvance_code) {
      // var tmp = null;
      // tmp = this.customer.filter((c) => c.name.includes(search_customer));

      // this.customer_id = tmp[0].id;
      // console.log("acvance_code : " + acvance_code);
      var tmp = acvance_code.split(" ");
      this.editedItem.code = tmp[0];
      this.editedItem.description = tmp[1];
    },
    async onSelectmiscellaneous_disbursementsChange() { },
    async saveeditItem() {
      this.desserts[this.editedIndex].miscellaneous_disbursements = this.dataeditItem.miscellaneous_disbursements;
      this.desserts[this.editedIndex].amount = this.dataeditItem.amount;
      console.log(this.desserts)
      this.desserts.forEach((item, index) => {
        item.amount = stringcommatonumber(item.amount.toString());
        item.amount_show = tolocalestringnumber(item.amount);
      });
      this.close();
      this.dialogEdit = false;
    },
    async closeeditItem() {
      this.dialogEdit = false;
    },
    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataeditItem.miscellaneous_disbursements = item.miscellaneous_disbursements;
      this.dataeditItem.amount = stringcommatonumber(item.amount.toString());
      this.dialogEdit = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      console.log(this.desserts)
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.amount_total = 0;
      this.desserts.forEach((item, index) => {
        this.amount_total += parseFloat(item.amount);
      });
      this.amount_total = tolocalestringnumber(this.amount_total);
      this.$emit("inv_mistab_data", this.desserts);
    },
    closeDelete() {
      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.amount_total = 0;
      this.desserts.forEach((item) => {
        this.amount_total += parseFloat(item.amount);
      });
      this.amount_total = tolocalestringnumber(this.amount_total);

      this.$emit("inv_mistab_data", this.desserts);
    },
    setupAlertDialog(status, titleMis, messageMis, text_colorMis) {
      this.titleMis = titleMis;
      this.messageMis = messageMis;
      this.dialogAddMis = status;
      this.text_colorMis = text_colorMis;
    },

    changeFocusText(t) {
      // alert(t);
      if (t === 1) {
        this.$refs["txtCode"].focus();
      } else if (t === 2) {
        this.$refs["txtDescription"].focus();
      } else if (t === 3) {
        if (this.editedItem.code == "") {
          alert("กรุณากรอกรหัสการขออนุมัติ");
          this.$refs["txtCode"].focus();
        } else {
          this.$refs["txtAmount"].focus();
        }
      }
    },

    saveMisTab() {
      if (this.editedItem.miscellaneous_disbursements == "" || !this.editedItem.miscellaneous_disbursements) {
        this.$store.state.global_dialog_invoice_mis = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณาเลือก Miscellaneous Disbursements",
          "text-h5 red--text text-center"
        );
        this.$refs["MiscellaneousDisbursements"].focus();
        return;
      }
      if (
        this.editedItem.miscellaneous_disbursements == "Others" &&
        (this.editedItem.specify_type == "" || !this.editedItem.specify_type)
      ) {
        this.$store.state.global_dialog_invoice_mis = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณาเลือกกรอกข้อมูล specify_type",
          "text-h5 red--text text-center"
        );
        this.$refs["SpecifyType"].focus();
        return;
      }

      if (this.editedItem.amount == "0" || this.editedItem.amount == 0 || !this.editedItem.amount) {
        this.$store.state.global_dialog_invoice_mis = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวนเงิน",
          "text-h5 red--text text-center"
        );
        this.$refs["txtAmount"].focus();
        return;
      }

      // if (this.editedIndex > -1) {
      //   Object.assign(this.desserts[this.editedIndex], this.editedItem);
      // } else {
      this.desserts.push(this.editedItem);
      // }

      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        item.amount = parseInt(item.amount);
        item.amount_show = tolocalestringnumber(item.amount);
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });
      console.log("save : " + JSON.stringify(this.desserts));
      // this.changeFocusText(1);
      this.close();
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthglessword {
  width: 30%;
}

.colorblack {
  color: black;
}
</style>
